import ProgressBar from './ProgressBar';

const components = {
  ProgressBar,
};

export default components;




// WEBPACK FOOTER //
// ./Components/index.js